import { REQUIRED_MESSAGE, requiredNumber } from '@wyz/utils';
import { z } from 'zod';

export const COUNTRY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const baseCountry = z.object({
  localId: z.string().nullish(),
  externalId: z.string(),
  name: z.string(),
  isoCode: z.string(),
  status: z.enum(COUNTRY_STATUS),
  invoicingCompanyId: z.number().nullish(),
  contact: z
    .object({
      email: z.string().nullish(),
      phone: z.string().nullish(),
    })
    .nullish(),
  labelEmailQuote: z.string().nullish(),
  labelEmailRedistribution: z.string().nullish(),
  defaultLabel: z.string(),
  chatId: z.string(),
});

export const countryConfigurationFormSchema = z
  .object({
    status: z.enum(COUNTRY_STATUS),
    contact: z.object({
      email: z.string().nullish(),
      phone: z.string().nullish(),
    }),
    invoicingCompanyId: requiredNumber,
    labelEmailQuote: z.string().nullish(),
    labelEmailRedistribution: z.string().nullish(),
    defaultLabel: z.string(),
    chatId: z.string(),
  })
  .superRefine((formData, ctx) => {
    // Conditional validation
    if (COUNTRY_STATUS.ACTIVE === formData.status) {
      if (!formData.contact?.email) {
        ctx.addIssue({
          code: 'custom',
          message: REQUIRED_MESSAGE,
          path: ['contact', 'email'],
        });
      }
      if (!formData.contact?.phone) {
        ctx.addIssue({
          code: 'custom',
          message: REQUIRED_MESSAGE,
          path: ['contact', 'phone'],
        });
      }
      if (!formData.labelEmailRedistribution) {
        ctx.addIssue({
          code: 'custom',
          message: REQUIRED_MESSAGE,
          path: ['labelEmailRedistribution'],
          fatal: true,
        });
      }

      if (!formData.labelEmailQuote) {
        ctx.addIssue({
          code: 'custom',
          message: REQUIRED_MESSAGE,
          path: ['labelEmailQuote'],
          fatal: true,
        });
      }
    }
  });

export const countryPayloadSchema = z.object({
  id: z.number(),
  status: z.enum(COUNTRY_STATUS),
  contact: z.object({
    email: z.string().nullish(),
    phone: z.string().nullish(),
  }),
  chatId: z.string(),
});
